<template>
    <gofix-card :title="title" :classHeader="title ? 'pb-10 pl-23' : ''" class="mb-0" fullContent>
        <gofix-default-table
            :settings="tableConfig"
            :table-items="tableItems"
            @load-items="getTableData"
            @new-item="newItem"
            @row-click="rowClick"
            @delete-items="deleteItems"
            @import-items="importItems"
            @export="exportItems"
            @mass-print="massPrint"
            @update-wo-number="updateWONumber"
            @filter-endorsed-DORJsStatus="filtersEndorsedDORJsStatus"
            ref="gofixTable">
            <template slot="gofix_table:after-control-custom-prr" slot-scope="row">
                <gofix-button class="ml-3 mr-3" :label="isFilterByImport ? '&times; Imported DORJs' : 'Imported DORJs'" outline @click="filterByImport()"></gofix-button>
            </template> 
            <template slot="gofix_table:before-control-right" slot-scope="row">
                <div class="d-flex ml-auto mr-4">
                    <div class="chartOfAccount">
                        <div class="d-flex align-items-center filterCompany">
                            <!-- <span class="mr-3 title">Finance Company</span> -->
                            <gofix-form-dropdown
                                class="highlightDropdown chartOfAccountDropdown"
                                label=""
                                vLabel="title"
                                :reduce="option => option.value"
                                :searchable="false"
                                placeholder="Filter with line items"
                                :options="[
                                    { value: false, title: 'DORJs with line items' },
                                    { value: true, title: 'DORJs with 0 line items' },
                                ]"
                                v-model="filterWithLineItems" />
                        </div>
                    </div>
                </div>
            </template> 
            <template slot="gofix_table:after-control-custom-dropdown" slot-scope="row">
                <b-dropdown-item @click="modals.show_no_invoice.open = true">Show No-Invoice</b-dropdown-item>
            </template>
            <template v-if="ClientContractID && ClientContractID.id && showImport" slot="gofix_table:before-control-right-setting-after-import">
                <b-dropdown-item @click="modalSubmitSFTP()" href="#">Import SFTP</b-dropdown-item>
                <b-dropdown-item @click="modalSubmitDocument()" href="#">Import DORJ</b-dropdown-item>
                <b-dropdown-item @click="modals.import_sor.open = true" href="#">Import SOR</b-dropdown-item>
            </template>      
            <template slot="gofix_table:replacement_date" slot-scope="row">
                {{ row.item.replacement_date ? row.item.replacement_date : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
            </template>
            <template slot="gofix_table:unit_price" slot-scope="row">
                {{ row.item.unit_price  | formatMoney }}
            </template>
            <template slot="gofix_table:total_value" slot-scope="row">
                {{ row.item.total_value  | formatMoney }}
            </template>
            <template slot="gofix_table:description" slot-scope="row">
                <div v-html="$options.filters.showDescriptionTable(row.item.description, row.item.description_two)"></div>
            </template>
            <template slot="gofix_table:warranty_period" slot-scope="row">
                {{ row.item.warranty_period ? `${row.item.warranty_period} months` : '--'}}
            </template>
            <template slot="gofix_table:warranty_expiry" slot-scope="row">
                {{row.item.warranty_expiry  | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
            </template>
            <template slot="gofix_table:invoice_date" slot-scope="row">
               {{ row.item.invoice_date ? row.item.invoice_date : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
            </template>
            <template slot="gofix_table:name_created_by" slot-scope="row">
                {{ row.item.created_by_user ? row.item.created_by_user.name : null }}
            </template>
            <template slot="gofix_table:name_updated_by" slot-scope="row">
                {{ row.item.updated_by_user ? row.item.updated_by_user.name : null }}
            </template>
            <template slot="gofix_table:created_on" slot-scope="row">
               {{ row.item.created_on ? row.item.created_on : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
            </template>
            <template slot="gofix_table:updated_on" slot-scope="row">
               {{ row.item.updated_on ? row.item.updated_on : null | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--')}}
            </template>
            <template slot="gofix_table:actions" slot-scope="row" v-if="row.item.data_source_from && row.item.data_source_from == 'LIVS'">
                <b-form-checkbox disabled></b-form-checkbox>
            </template>
            <template slot="gofix_table:first_print_date" slot-scope="row">
                {{ row.item.first_print_date ? row.item.first_print_date : '' | formatsDate }}
            </template>
            <template slot="gofix_table:latest_print_date" slot-scope="row">
                {{ row.item.latest_print_date ? row.item.latest_print_date : '' | formatsDate }}
            </template>
            <template slot="gofix_table:wo_date" slot-scope="row">
                {{ row.item.wo_date ? row.item.wo_date : '' | formatDatebyMoment("YYYY-MM-DD", $formatDateLift, '--') }}
            </template>
            <template slot="gofix_table:dorj_date" slot-scope="row">
                {{ row.item.dorj_date ? row.item.dorj_date : '' | formatDatebyMoment("YYYY-MM-DD", $formatDateLift, '--') }}
            </template>
            <template slot="gofix_table:payment_date" slot-scope="row">
                {{ row.item.payment_date ? row.item.payment_date : '' | formatDatebyMoment("YYYY-MM-DD", $formatDateLift, '--') }}
            </template>
            <template slot="gofix_table:acknowledged_on" slot-scope="row">
                {{ row.item.acknowledged_on ? row.item.acknowledged_on : '' | formatDatebyMoment("YYYY-MM-DD HH:mm:ss", $formatDateLift, '--') }}
            </template>
            <template slot="gofix_table:job_inspection_date" slot-scope="row">
                {{ row.item.job_inspection_date ? row.item.job_inspection_date : '' | formatDatebyMoment("YYYY-MM-DD", $formatDateLift, '--') }}
            </template>
        </gofix-default-table>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-Create"
            title="Add Parts Replacement" 
            hide-footer 
            :centered="true" 
            v-model="modal.open">
            <template v-if="is_in_contract">
                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Equip. Tag" oneline>{{ part_replacement.tag_name }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Lift Number" oneline>{{ part_replacement.lift_number }}</gofix-text-field>
                    </b-col>
                </b-row>

                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Constituency" oneline>{{ part_replacement.constituency }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Block" oneline>{{ part_replacement.blk_number }}</gofix-text-field>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col md="12" class="mb-16">
                        <gofix-text-field class-label="width-115" label="Postal Code" oneline>{{ part_replacement.postal_code }}</gofix-text-field>
                    </b-col>
                    <hr class="w-100 mt-5 mb-20" />
                </b-row>
            </template>
            <template v-else>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-form-dropdown
                            label="Equipment Tag"
                            v-model="part_replacement.equipment"
                            vLabel="tag_name"
                            required
                            :options="equipments"
                            @search="searchEquipment"
                            :clearable="false" 
                            :filterable="false">
                            <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                                <div class="flex">
                                    <div class="">
                                        <span>{{option.tagConstituency }}</span>
                                    </div>
                                </div>
                            </template>
                            <template slot="gofixInput:dropdown:option" slot-scope="option">
                                <span>{{option.tagConstituency}}</span>
                            </template>
                        </gofix-form-dropdown>
                    </b-col>
                </b-row> 
                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Lift Company" oneline>{{ part_replacement.lift_company }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Constituency" oneline>{{ part_replacement.constituency }}</gofix-text-field>
                    </b-col>
                </b-row>
                <!--<b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Lift Number" oneline>{{ part_replacement.lift_number }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="Block" oneline>{{ part_replacement.blk_number }}</gofix-text-field>
                    </b-col>
                </b-row>-->
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-text-field class-label="width-115" label="Blk Address" oneline>{{ part_replacement.blk_address }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="mb-16">
                    <b-col md="12">
                        <gofix-text-field class-label="width-115" label="Postal Code" oneline>{{ part_replacement.postal_code }}</gofix-text-field>
                    </b-col>
                </b-row>
                <!--<b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="McoID" oneline>{{ part_replacement.mco_id }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="TMS Batch No" oneline>{{ part_replacement.tms_batch_no }}</gofix-text-field>
                    </b-col>
                </b-row>
                <b-row class="mb-16">
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="TMS Batch Date" oneline>{{ part_replacement.tms_batch_date }}</gofix-text-field>
                    </b-col>
                    <b-col md="6">
                        <gofix-text-field class-label="width-115" label="TMS Lift ID" oneline>{{ part_replacement.tms_lift_id }}</gofix-text-field>
                    </b-col>
                </b-row>-->
            </template>
            <b-row>
                <!--<template v-if="is_in_contract">
                    <b-col md="12">
                        <gofix-form-input label="Lift Company" v-model="part_replacement.lift_company"></gofix-form-input>
                    </b-col>
                </template>-->
                <b-col md="6">
                    <gofix-form-input label="DORJ Number" v-model="part_replacement.dorj_number"></gofix-form-input>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-date 
                        label="DORJ Date" 
                        popoverDirection="top"
                        v-model="part_replacement.dorj_date" >
                    </gofix-form-input-date>
                </b-col>
                <b-col md="12">
                    <gofix-form-input-date 
                        label="Repl.Date" 
                        popoverDirection="top"
                        v-model="part_replacement.replacement_date" >
                    </gofix-form-input-date>
                </b-col>
                <b-col md="6">
                    <gofix-form-dropdown
                        label="GL Code"
                        :options="COA"
                        v-model="part_replacement.gl_code"
                        vLabel="name"
                        :filterable="false"
                        :reduce="option => option.gl_code"
                        @search="searchCOA">
                    <template slot="gofixInput:dropdown:selected-option" slot-scope="option">
                        <div class="flex">
                            <div class="">
                                {{ option.gl_code + " " + option.name }}
                            </div>
                        </div>
                    </template>
                    <template slot="gofixInput:dropdown:option" slot-scope="option">
                        {{ option.gl_code + " " + option.name }}
                    </template>
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="6">
                    <gofix-form-dropdown
                        label="Lift Brand"
                        v-model="part_replacement.lift_brand"
                        vLabel="name"
                        :reduce="option => option.name"
                        required
                        :options="liftBrandOption">
                    </gofix-form-dropdown>
                </b-col>
                <!--<b-col md="6">
                    <gofix-form-input label="Invoice Ref No" v-model="part_replacement.invoice_ref"></gofix-form-input>
                </b-col>
                <b-col md="6">
                    <gofix-form-input-date 
                        label="Invoice Date" 
                        v-model="part_replacement.invoice_date" >
                    </gofix-form-input-date>
                </b-col>
                <b-col md="12">
                    <gofix-form-input-date 
                        label="Payment Date" 
                        v-model="part_replacement.payment_date" >
                    </gofix-form-input-date>
                </b-col>-->
                <b-col md="6">
                    <gofix-form-dropdown
                        label="Job Type"
                        v-model="part_replacement.job_type"
                        required
                        :options="rep_type_options">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="6">
                    <gofix-form-dropdown
                        label="Invoice Type"
                        vLabel="reference_value_text"
                        v-model="part_replacement.invoice_type"
                        required
                        :options="invoice_type_options">
                    </gofix-form-dropdown>
                </b-col>
                <b-col md="12">
                    <gofix-form-input label="Remarks" v-model="part_replacement.remarks"></gofix-form-input>
                </b-col>
            </b-row>
            <b-button-group class="d-block text-right pr-4">
                <gofix-button label="APPLY" @click="checkValidateDORJ" :disabled="modal.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal id="modal-Remove" :no-close-on-backdrop="true"  title="Continue" hide-footer hide-header :centered="true" v-model="toast.open">
            <div class="center px-3">
                <p><strong>{{ toast.equipment_tag }}</strong></p>
                <!--<span>Do you want to proceed?</span>-->
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="toast.open = false">Cancel</b-button>
                <!--<b-button class="custom-btn" @click="saveItem">Continue
                </b-button>-->
            </b-button-group>
        </b-modal>
        <b-modal v-if="ClientContractID && ClientContractID.id" :no-close-on-backdrop="true" @hide="resetImport" title="import file" id="modal-Import" hide-footer v-model="modals.import_sor.open">
            <b-form>
                <b-row>
                    <b-col>
                        <gofix-form-supplier
                            label="Default Supplier"
                            :reduce="option => option.id"
                            :contract-id="ClientContractID.id"
                            v-model="modals.import_sor.supplier">
                        </gofix-form-supplier>
                    </b-col>
                </b-row>
                <b-form-group>
                    <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="modals.import_sor.check" ref="file-input-bdj" accept=".csv" v-model="modals.import_sor.file" >
                        <template slot="file-name" slot-scope="{ names }">
                        <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                        </template>
                    </b-form-file>
                </b-form-group>
                <b-button-group class="d-block text-right">
                    <gofix-button label="SUBMIT" @click="importSor" :loading="modals.import_sor.loading"  noBorder></gofix-button>
                </b-button-group>
            </b-form>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.export.process}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
        <b-modal 
            :no-close-on-backdrop="true" 
            id="modal-noInvoice"
            class="modal-noInvoice"
            title="Show No-Invoice" 
            hide-footer 
            :centered="true" 
            v-model="modals.show_no_invoice.open">
            <gofix-form-input-number 
                label="Show entries without invoice for more than" 
                desc="days"
                v-model="modals.show_no_invoice.data.day_show_no_invoice">
            </gofix-form-input-number>
            <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                <gofix-button label="CANCEL" @click="cancelNoInvoice" noBorder dark></gofix-button>
                <gofix-button label="SHOW" @click="showNoInvoice" :loading="modals.show_no_invoice.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modal.process.title" hide-footer :centered="true" v-model="modal.process.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modal.process.text}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" size="xl" id="modal-Create" :title="modal.embed.title" hide-footer :centered="true" v-model="modal.embed.open">
            <iframe id="mass-print-pdf" src="" style="width: 100%; height: 80vh;"></iframe>
        </b-modal>
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-Import"
            :title="modals.sftp.title"  
            hide-footer 
            v-model="modals.sftp.open">
            <b-row>
                <b-col md="12">
                    <gofix-form-dropdown
                        :multiple="false"
                        label="File Type"
                        vLabel="name"
                        :clearable="false"
                        :options="['DORJ', 'INVOICE']"
                        v-model="modals.sftp.data.file_type"
                        required />
                </b-col>
                <b-col md="12">
                    <gofix-form-dropdown
                        label="Supplier"
                        vLabel="name"
                        :filterable="false"
                        :append-to-body="true"
                        :required="true"
                        :options="modals.options.suppliers"
                        @search="searchOrganization"
                        v-model="modals.sftp.data.supplier">
                    </gofix-form-dropdown>
                </b-col>
            </b-row>
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="submitDocumentSFTP" noBorder :disabled="modals.sftp.loading == true"></gofix-button>
            </b-button-group>
        </b-modal>
        <!-- /**/ -->
        <b-modal 
            :no-close-on-backdrop="true" 
            id="update-wo-number"
            class="modal-noInvoice"
            :title="modals.update_wo_number.title" 
            :centered="true" 
            hide-footer 
            size="xl"
            v-model="modals.update_wo_number.open">
            <b-container>
                <b-row>
                    <b-col class="pb-3"> <strong >DORJ Number</strong> </b-col>
                    <b-col class="pb-3"> <strong>WO Number</strong> </b-col>
                    <b-col class="pb-3"> <strong>WO Date</strong> </b-col>
                </b-row>
                <b-row v-for="(item, index) in this.modals.update_wo_number.data">
                    <b-col>
                        <gofix-form-input
                            label="WO Number"
                            disabled
                            v-model="item.dorj_number">
                        </gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-input
                            label="WO Number"
                            v-model="item.wo_ref_no">
                        </gofix-form-input>
                    </b-col>
                    <b-col>
                        <gofix-form-input-date 
                            label="WO Date"
                            v-model="item.wo_date">
                        </gofix-form-input-date>
                    </b-col>
                </b-row>
            </b-container>
            <b-button-group class="d-block text-right pr-4 clear-both mb-3">
                <gofix-button label="SUBMIT" @click="submitUpdateWONumber" :loading="modals.update_wo_number.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <!--  -->
        <b-modal 
            :no-close-on-backdrop="true"
            id="modal-Import"
            title="Import DORJ"  
            hide-footer 
            v-model="modals.import_dorj.open">
            <b-row>
                <b-col md="12">
                    <gofix-form-dropdown
                        label="Supplier"
                        vLabel="name"
                        :filterable="false"
                        :append-to-body="true"
                        :required="true"
                        :options="modals.options.suppliers"
                        @search="searchOrganization"
                        v-model="modals.import_dorj.data.supplier">
                    </gofix-form-dropdown>
                </b-col>
            </b-row>
            <b-form-group>
                <b-form-file @input="changeFile" placeholder="Click Browse to upload file" :state="modals.check" ref="file-input-bdj" accept=".csv" v-model="modals.import_dorj.data.file" >
                    <template slot="file-name" slot-scope="{ names }">
                    <span class="import-input-text-ellipsis" variant="dark">{{ names[0] }}</span>
                    </template>
                </b-form-file>
            </b-form-group>
            <b-button-group class="text-right d-block">
                <gofix-button label="SUBMIT" @click="submitDocumentDORJ" noBorder :disabled="modals.import_dorj.loading == true"></gofix-button>
            </b-button-group>
        </b-modal>
    </gofix-card>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import { filters } from '@/_filterVar.js'
    import { PDFDocument } from 'pdf-lib';
        export default {
        name: 'parts-replacement',
        components: {},
        props: {
            is_in_contract: {
                type: Boolean,
                default: false
            },
            valueTitle: {
                type: String,
                default: ''
            },
            nameTable: {
                type: String,
                default: ''
            },
            showImport:{
                type:Boolean,
                default:false
            },
            supplier:{
                type:Boolean,
                default:false
            }
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['parts_replacement_history']));
            return {
                title: this.valueTitle,
                tableConfig:{
                    name: this.nameTable,
                    controls:{
                        create: this.$checkRole(this.$accessModule.parts_replacement, 'create'),
                        delete: this.$checkRole(this.$accessModule.parts_replacement, 'delete'),
                        massPrint: true,
                        updateWONumber: true,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "equipment_tag",
                    sortDirection: "desc",
                    leftWidth: 5,
                    rightWidth: 7
                },
                tableItems:[],
                modal: {
                    open: false,
                    loading: false,
                    timer: null,
                    process: {
                        title: 'Print Stamped DORJs',
                        open: false,
                        text: 'processing...',
                    },
                    embed:{
                        title: 'Mass Print Preview',
                        open: false,
                    }
                },
                modals:{
                  import_sor:{
                    open:false,
                    loading: false,
                    check:'',
                    file:null,
                    fileName: "Click Browse to upload file",
                    supplier : null,
                    supplier_id : null,
                  },
                  export:{
                    open:false,
                    loading:false,
                    process:'Creating file csv',
                    title: 'Export Data'
                    },
                    show_no_invoice:{
                        open: false,
                        loading: false,
                        timer: null,
                        data:{
                            day_show_no_invoice:null
                        }
                    },
                    sftp: {
                        open: false,
                        loading: false,
                        title: 'Import Document from SFTP',
                        data: {
                            submission_mode:'SFTP',
                            fitle_type:'DORJ',
                            supplier: null
                        },
                    },
                    update_wo_number: {
                        open: false,
                        loading: false,
                        title: 'Update WO Number',
                        data: [],
                    },
                    import_dorj: {
                        open: false,
                        loading: false,
                        data: {
                            supplier: null,
                            file: null
                        }
                    },
                    options: {
                        suppliers: []
                    }
                },
                invoice_type_options: ['MINOR', 'MAJOR', 'OTHERS'],
                rep_type_options: ['Normal', 'Cyclical'],
                lift_manufacturers: [],
                part_replacement: {
                    equipment: null,
                    equipment_id: null,
                    contract_id: null,
                    lift_company: null,
                    invoice_ref: null,
                    invoice_date: null,
                    payment_date:null,
                    remarks: null,
                    job_type: null,
                    invoice_type: null,
                    tag_name: null,
                    tc_code: null,
                    address_prefix: null,
                    lift_code: '',
                    lift_number: null,
                    constituency: null,
                    blk_number: null,
                    postal_code: null,
                    blk_address:null,
                    mco_id: null,
                    tms_batch_no: null,
                    tms_batch_date: null,
                    tms_lift_id: null,
                    dorj_number:null,
                    dorj_date:null,
                    replacement_date:null,
                    gl_code:null,
                    lift_brand:null
                },
                timer: null,
                equipments: [],
                toast:{
                    open: false,
                    loading: false,
                    timer: null,
                    equipment_tag:null
                },
                liftBrandOption:[],
                brands:{
                    timer:null
                },
                glCodes: [],
                EndorsedDORJsStatus: {
                    label: 'Endorsed DORJs',
                    status: 0,
                },
                cssText: ` @page { size: auto;  margin: 0mm 0mm 0mm 0mm; } `,
                isFilterByImport: false,
                filterWithLineItems: null
            }
        },
        filters: {
            showDescriptionTable(description_one, description_two) {
                let description = description_one;
                if(description_two) {
                    description += ` - <span class="color-red">${description_two}<span>`;
                }
                return description;
            },
            formatsDate: function(value) {
                if (!value) return "--";
                return moment(new Date(value)).format("DD.MM.YYYY HH:mm:ss");
            }
        },
        created() {
            if(this.ClientContractID && this.ClientContractID.id) {
                this.getGLCode();
                if(!this.is_in_contract)  this.getEquipment();
            }
            this.getListLiftManufacturer();

            this.tableConfig.filter.status.value = '';
            this.EndorsedDORJsStatus.label = 'Endorsed DORJs'
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
                equipment:"EquipmentV2Controller/equipment",
                COA: 'FmCodeController/coa',
            }),
        },
        watch: {
            ClientContractID: function(val) {
                if(val) {
                    this.getEquipment();
                    this.getGLCode();

                    this.tableConfig.filter.status.value = '';
                    this.EndorsedDORJsStatus.label = 'Endorsed DORJs'
                    this.EndorsedDORJsStatus.status = 0
                }
            },
            "part_replacement.equipment": function(val) {
                if(val) {
                    this.setPartsReplacement(val);
                }
            },
             "modals.import_sor.file": function(val, old) {
                if (val) {
                    let arrExtionsionAccept = ['csv']
                    let split = val.name.split('.');
                    let extension = split[split.length - 1].toLowerCase();
                    if(!arrExtionsionAccept.includes(extension)) {
                    this.$refs['file-input-bdj'].reset();
                    return this.$alertNotification("File format is incorrect. Please select a .csv file!", "primary");
                    }
                    return this.modals.import_sor.fileName = val.name;
                }
                return this.modals.import_sor.fileName = 'Click Browse to upload file'
            }, 
            filterWithLineItems: function(val, old) {
                this.$refs.gofixTable.reloadTableItems();
            }
        },
        methods: {
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                if(this.$route.params.hasOwnProperty('equipment_id')) {
                    tableRequest.filter.equipment_id.value = this.$route.params.equipment_id;
                }

                if(this.filterWithLineItems === false || this.filterWithLineItems === true){
                    tableRequest.filter.is_show_DORJ_without_line_items = this.filterWithLineItems;
                } else {
                    delete tableRequest.filter.is_show_DORJ_without_line_items
                }

                await this.$store.dispatch("PartReplacementController/getPartReplacementHistory", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load part replacement history.", "danger");
                    reject();
                });
            },
            async getEquipment(tag_name = null) {
                this.equipments = []
                let tableRequest = {
                    filter: {
                        contract_id: this.ClientContractID.id,
                        tag_name: tag_name,
                        is_active: true
                    },
                    limit: 50,
                    isCMS: false,
                    sortColumn: 'tag_name',
                    sortDirection: 'ASC',
                }
                await this.$store.dispatch("PartReplacementController/getEquipment", tableRequest)
                .then(response => {
                    this.equipments = response.items;
                }).catch(err => {})
            },
            async searchEquipment(search, loading) {
                loading(true)
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getEquipment(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 1000);
            },
            newItem() {
                this.part_replacement = {
                    equipment_id: null,
                    lift_company: null,
                    invoice_ref: null,
                    invoice_date: null,
                    payment_date:null,
                    remarks: null,
                    job_type: null,
                    invoice_type: 'MINOR',
                    tag_name: null,
                    gl_code:null,
                    tc_code: null,
                    address_prefix: null,
                    lift_code: '',
                    lift_number: null,
                    constituency: null,
                    blk_number: null,
                    postal_code: null,
                    blk_address:null,
                    dorj_number:null,
                    dorj_date:null,
                    replacement_date:null,
                    lift_brand:null
                }
                if(this.is_in_contract) {
                    this.setPartsReplacement(this.equipment);
                    this.modal.open = true;
                } else {
                    if(!this.ClientContractID || !this.ClientContractID.id) {
                        return this.$alertNotification("Please choose a contract.", "danger");
                    }
                    this.part_replacement.contract_id = this.ClientContractID.id;
                    this.modal.open = true;
                }
            },
            setPartsReplacement(val) {
                if(val) {
                    let location = val.location_info ? val.location_info.name:'';
                    this.part_replacement.equipment_id = val.id;
                    this.part_replacement.contract_id  = val.contract_id;
                    this.part_replacement.tag_name = val.tag_name;
                    if(val.custom_fields) {
                        let custom_fields = val.custom_fields;
                        custom_fields.map(item => {
                            let key = item.attribute.name ? item.attribute.name.toLowerCase().replaceAll(' ', '_') : '';
                            if(key == 'block_no' || key == 'block_number') key = 'blk_number';
                            if(key == 'lift_no' || key == 'lift_letter') key = 'lift_number';
                            if(key == 'address_prefix' || key == 'prefix') key = 'address_prefix';
                            if(this.part_replacement.hasOwnProperty(key)) {
                                let value = item.value;
                                if(value && item.attribute.type === "DateTime") {
                                    value = moment(value).format("DD.MM.YYYY");
                                }
                                if(value){
                                    this.part_replacement[key] = value;
                                }
                            }
                        })
                    }
                    if(this.part_replacement.tc_code) {
                        this.part_replacement.lift_code = `${this.part_replacement.tc_code}-`;
                    }
                    if(this.part_replacement.address_prefix) {
                        this.part_replacement.lift_code += `${this.part_replacement.address_prefix}-`;
                    }
                    if(this.part_replacement.blk_number) {
                        this.part_replacement.lift_code += `${this.part_replacement.blk_number}-`;
                    }
                    if(this.part_replacement.lift_number) {
                        this.part_replacement.lift_code += this.part_replacement.lift_number;
                    }
                    this.part_replacement.blk_address = location;
                }
            },
            async checkValidateDORJ(){
                this.toast.equipment_tag = null
                this.toast.open = false
                if(this.ClientContractID.id && 
                this.part_replacement.lift_company && 
                this.part_replacement.dorj_number && 
                this.part_replacement.dorj_date){
                    let tableRequest = {
                        filter: {
                            contract_id: this.ClientContractID.id,
                            lift_company: this.part_replacement.lift_company,
                            dorj_number: this.part_replacement.dorj_number
                        },
                        limit: 1,
                        isCMS: 0,
                    }
                    await this.$store.dispatch("PartReplacementController/getPartReplacementHistoryHeader", tableRequest)
                    .then(response => {
                        if(response.data.data.items.length > 0){
                            //this.toast.equipment_tag = response.data.data.items[0].equipment_tag
                            this.toast.equipment_tag = `Duplicate DORJ with DORJ Number(${this.part_replacement.dorj_number}) and Lift Company(${this.part_replacement.lift_company})`
                            this.toast.open = true
                        }else{
                            this.saveItem();
                        }
                    }).catch(err => {})
                    return;
                }
                this.saveItem();
            },
            saveItem() {
                if (this.modal.timer) {
                    clearTimeout(this.modal.timer);
                    this.modal.timer = null;
                }
                this.modal.timer = setTimeout(async () => {
                    if(!this.part_replacement.equipment_id) {
                        return this.$alertNotification("Please choose a equipment tag.", "danger");
                    }

                    this.modal.loading = true;
                    let objeClone = {
                        equipment_id:    this.part_replacement.equipment_id,
                        contract_id:     this.part_replacement.contract_id,
                        lift_company:    this.part_replacement.lift_company,
                        invoice_ref:     this.part_replacement.invoice_ref,
                        invoice_date:    this.part_replacement.invoice_date ? moment(this.part_replacement.invoice_date).format("YYYY-MM-DD") : null,
                        payment_date:    this.part_replacement.payment_date ? moment(this.part_replacement.payment_date).format("YYYY-MM-DD") : null,
                        remarks:         this.part_replacement.remarks,
                        job_type:        this.part_replacement.job_type,
                        invoice_type:    this.part_replacement.invoice_type,
                        dorj_number:     this.part_replacement.dorj_number,
                        dorj_date:       this.part_replacement.dorj_date ? moment(this.part_replacement.dorj_date).format("YYYY-MM-DD") : null,
                        replacement_date: this.part_replacement.replacement_date ? moment(this.part_replacement.replacement_date).format("YYYY-MM-DD") : null,
                        data_source_from: "GoFix",
                        status: "Draft",
                        lift_brand: this.part_replacement.lift_brand ? this.part_replacement.lift_brand:null,
                        gl_code: this.part_replacement.gl_code ? this.part_replacement.gl_code:null
                    };

                    this.$store.dispatch("PartReplacementController/createItem", objeClone)
                    .then(async response => {
                        this.modal.loading = false;
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.modal.open = false;
                        if(!this.is_in_contract) {
                            if(this.supplier || this.$checkSupplier()){
                                await this.$router.push(`/supplier-portal/parts-replacement/${response.livs_transaction_id}`)
                            }else{
                                await this.$router.push(`/v2/parts-replacement/${response.livs_transaction_id}`)
                            }
                        } else {
                            await this.$router.push(`/v2/contract-client/${this.$route.params.id}/equipment/${this.$route.params.equipment_id}/part-replacement/${response.livs_transaction_id}`)
                        }
                        await this.$alertNotification(this.$notificationV2('adding', 'parts_replacement_history'));
                    })
                    .catch(err => {
                        this.modal.loading = false;
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    })

                }, 200);
            },
            rowClick(item) {
                this.$emit('row-click', item);
            },
            async deleteItems(callback){
                const {
                    ids,
                    filter,
                    resolve,
                    reject
                } = await callback();
                let header_ids = ids.filter(item => {
                    if(!item.item_id) return item.id
                }).map(({ id }) => Number(id))
                let item_ids = ids.filter(item => {
                    if(item.item_id) return item.item_id
                }).map(({ item_id }) => item_id)

                Promise.all([
                    this.deleteHeaders(header_ids),
                    this.deleteLineItems(item_ids),
                ]).then((values) => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    resolve(this.$notificationV2('deleting', 'parts_replacement_history'))
                }).catch(err => {
                    reject();
                });
                
            },
            deleteHeaders(ids) {
                if(ids.length) {
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch('PartReplacementController/deleteHeaders', ids)
                        .then(response => {
                            resolve(true)
                        })
                        .catch(err => {
                            reject();
                        })
                    })
                }
                return Promise.resolve(true);
            },
            deleteLineItems(ids) {{
                if(ids.length) {
                    return new Promise((resolve, reject) => {
                        this.$store.dispatch('PartReplacementController/deleteItems', ids)
                        .then(response => {
                            resolve(true)
                        })
                        .catch(err => {
                            reject();
                        })
                    })
                }
                return Promise.resolve(true);
            }},
            async importItems(callback){
                const { file, resolve, reject } = await callback();
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    resolve([]);
                    return this.$alertNotification("Please choose a contract.", "danger");
                }

                await this.$store.dispatch(`PartReplacementController/importItems`, {
                    contract_id: this.ClientContractID.id,
                    file_import: file
                })
                    .then(response => {
                        let variant = 'success';
                        let msg = this.$alertNotification("Import success part replacement.", "success");
                        let result = response.data.data;
                        if(result.data && result.data.count && result.data.count.failed ) {
                            variant = 'danger';
                            msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                        }

                        this.$alertNotification(msg, variant);
                        resolve();
                    })
                    .catch(error => {
                        reject(error);
                    });
            },
            exportItems(tableRequest) {
                if(!this.ClientContractID || !this.ClientContractID.id) {
                    return this.$alertNotification("Please choose a contract.", "danger");
                }
                let request = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
                request.contract_id = this.ClientContractID.id;
                let that = this;
                this.modals.export.open = true;
                this.modals.export.process = "Creating file csv";

                global.axios.get(`/api/equipment/part-replacement-history/export`, {
                    params: request,
                    responseType: 'blob',
                    onDownloadProgress (progress) {
                        that.modals.export.process = "Export in Progress";
                    }
                })
                .then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'PartReplacementHistoryList.csv'); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    this.modals.export.open = false
                })
                .catch(error => {
                    this.modals.export.open = false
                    console.log(error);
                });
            },
            resetImport(){
                this.modals.import_sor.check = '';
                this.modals.import_sor.file = null;
            },
            changeFile(){
                this.modals.import_sor.check = this.modals.import_sor.file ? false : true;
            },
            async importSor(){
                if(this.modals.import_sor.loading) return ;
                if (!this.modals.import_sor.file) {
                    return this.$alertNotification("Please choose file to import", "danger");
                }
                if (!this.modals.import_sor.supplier) {
                    return this.$alertNotification("Please choose a default supplier", "danger");
                }
                this.modals.import_sor.loading = true;
                await this.$store.dispatch(`v2SorController/importSORVerersioning`, {
                    contract_id: this.ClientContractID.id,
                    supplier_id: this.modals.import_sor.supplier.id,
                    file: this.modals.import_sor.file
                })
                .then(response => {
                    let variant = 'success';
                    let msg = this.$notificationV2('importing', 'sor');
                    let result = response.data.data;
                    if(result.data && result.data.count && result.data.count.failed ) {
                    variant = 'danger';
                    msg = "Some rows cannot be imported. Please go to Import Logs for more details.";
                }
                    this.$alertNotification(msg, variant);
                    this.modals.import_sor.open = false;
                    this.modals.import_sor.loading = false;
                })
                .catch(err => {
                    this.modals.import_sor.loading = false;
                    let msg = "Can't import data!";
                    if( err.response.data.error
                      && err.response.data.error.message
                    ){
                        msg = err.response.data.error.message;
                    }
                    return this.$alertNotification(msg, "danger");
                });
            },
            async getGLCode(search = ''){
                this.$store.dispatch("FmCodeController/getCOA",{limit: 100, filter: {
                    coa_company_id: this.ClientContractID && this.ClientContractID && this.ClientContractID.finance_company && this.ClientContractID.finance_company.finance_company_id ? this.ClientContractID.finance_company.finance_company_id : null,
                    search: search
                }});
                // let work_type = null;
                // if(this.part_replacement.job_type == 'Normal') work_type = 'Reactive'
                // if(this.part_replacement.job_type == 'Cyclical') work_type = 'Preventive'
                // await this.$store.dispatch("FmCodeController/getFmCodeItems",{
                //     limit: 100,
                //     page: 1,
                //     contract_id: this.ClientContractID.id,
                //     filter: {
                //         work_type: work_type,
                //         service_category_name: this.part_replacement.part_category || null,
                //         gl_code: search
                //     }
                // })
                // .then(response => {
                //     this.glCodes = response.items
                // });

            },
            searchCOA(search, loading){
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getGLCode(search)
                        await loading(false)
                    } catch (error) {
                        loading(false)
                    }
                }, 500);
            },
            async fetchDataNoInvoice(tableRequest){
                this.modals.show_no_invoice.loading = true;
                if(this.$route.params.hasOwnProperty('equipment_id')) {
                    tableRequest.filter.equipment_id.value = this.$route.params.equipment_id;
                }
                await this.$store.dispatch("PartReplacementController/getPartReplacementHistory", tableRequest)
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    this.modals.show_no_invoice.open  = false;
                    this.modals.show_no_invoice.loading = false;
                    //resolve(response);
                })
                .catch(err => {
                    this.$alertNotification("Can not load part replacement history.", "danger");
                    this.modals.show_no_invoice.open  = false;
                    this.modals.show_no_invoice.loading = false;
                    console.log(err);
                });
            },
            async showNoInvoice(){
                if(!this.modals.show_no_invoice.data.day_show_no_invoice){
                    return this.$alertNotification("This field is required.", "danger");
                }
                this.$refs.gofixTable.tableRequest.filter.day_invoice_no.value = this.modals.show_no_invoice.data.day_show_no_invoice;
                await this.fetchDataNoInvoice(this.$refs.gofixTable.tableRequest);
            },
            async cancelNoInvoice(){
                this.$refs.gofixTable.tableRequest.filter.day_invoice_no.value = null;
                await this.fetchDataNoInvoice(this.$refs.gofixTable.tableRequest);
                this.modals.show_no_invoice.open = false
                this.modals.show_no_invoice.data.day_show_no_invoice = null
            },
            getListLiftManufacturer() {
                this.$store.dispatch("MasterBrandController/getItems", {
                    page: 1,
                    limit: -1,
                    sortColumn: "name",
                    sortDirection: "ASC",
                    filter: {
                        contract_id: null,
                    }
                })
                .then(response => {
                    this.liftBrandOption = response.items;
                })
                .catch(err => {
                    this.liftBrandOption = [];
                })
            },
            async filtersEndorsedDORJsStatus(callback) {
                if ( this.EndorsedDORJsStatus.status == 0 ) {
                    this.tableConfig.filter.status.value = 'DORJ Endorsed';
                    this.EndorsedDORJsStatus.status = 1
                } else {
                    this.tableConfig.filter.status.value = '';
                    this.EndorsedDORJsStatus.status = 0
                }
                
                this.$refs.gofixTable.reloadTableItems();
            },
            async massPrint(callback){
                const { ids, resolve, reject } = await callback();
                let header_ids = ids.map(({ id }) => Number(id))
                header_ids = Array.from(new Set(header_ids))
                await this.$store.dispatch('PartReplacementController/massPrint', header_ids)
                .then(response => {

                    if ( response.items.length == 0 ) {
                        return this.$alertNotification("No Stamped DORJs found", "danger");
                    }
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.processPDF(response.items)
                })
                .catch(err => {
                    console.log(err)
                    reject();
                })
            },
            async processPDF(items) {
                return new Promise(async (resolve, reject) => {

                    this.modal.process.open = true
                    var pdfDoc = await PDFDocument.create();
                    
                    for ( const item of items ) {

                        if ( item.image_content_type != 'application/pdf' ) {
                            continue;
                        }

                        let params = {
                                url: item.url.original,
                                image_file_name: item.image_file_name,
                            };
                        
                        let response = await this.$store.dispatch("FileDownloadController/getFileNotDownload", params);

                        if ( response ) {
                            let existingPdfBytes = await response.arrayBuffer().then(buffer => buffer)
                            var bytes = new Uint8Array(existingPdfBytes);
                            let pdfDoc_ = await PDFDocument.load(bytes)
                            
                            if ( response.type == 'application/pdf' ) {
                                
                                let contentPDF = await pdfDoc.copyPages(pdfDoc_, pdfDoc_.getPageIndices());
                                for ( let page of contentPDF ) {
                                    if ( page ) {
                                        pdfDoc.addPage(page);
                                    }
                                }
                            }
                        }
                    }
                    
                    var pdfBytes = await pdfDoc.save();
                    this.modal.process.open = false
                    this.modal.embed.open = true
                    
                    /* */
                    // const pdfDataUri = await pdfDoc.saveAsBase64({ dataUri: true });
                    // document.getElementById('mass-print-pdf').src = pdfDataUri;

                    const blob = new Blob([pdfBytes], { type: "application/pdf" });
                    let response_url = await this.$store.dispatch("AttachmentController/getTempUrl", {
                        file: new File([blob], 'temp.pdf', {type: 'application/pdf'})
                    });

                    document.getElementById("mass-print-pdf").src = response_url.data.url;
                });
            },
            modalSubmitSFTP(){
                this.modals.sftp.data = {
                    submission_mode: 'SFTP',
                    file_type:'DORJ'
                };
                this.getOrganizations();
                this.modals.sftp.open = true;
            },
            async submitDocumentSFTP(){
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    if(!this.modals.sftp.data.supplier) return this.$alertNotification("Supplier is required", "danger");
                    this.modals.sftp.loading = true;

                    let request = {
                        file_type: this.modals.sftp.data.file_type,
                        submission_mode: this.modals.sftp.data.submission_mode,
                        supplier_id: this.modals.sftp.data.supplier.id
                    }
                    await this.$store.dispatch(`BatchSubmissionController/importItemsSFTP`, request)
                    .then(response => {
                        this.$alertNotification("Submiited. Please check log for detail!", "success");
                        this.$refs.gofixTable.reloadTableItems();
                        this.modals.sftp.open = false
                        this.modals.sftp.loading = false
                    })
                    .catch(error => {
                        this.modals.sftp.loading = false
                        this.modals.sftp.open = false
                        this.$refs.gofixTable.reloadTableItems();
                        if (error.response.data.error && error.response.data.error.message) {
                            this.$alertNotification(error.response.data.error.message, "danger")
                        }
                    });
                }, 300);
            },
            async getOrganizations(search) {
                await this.$store.dispatch( 'OrganizationController/searchOrganizations', { is_supplier: true, name: search })
                .then(response => {
                    this.modals.options.suppliers = response.data.data;
                })
                .catch(err=>{ 
                    console.log(err);
                })
            },
            searchOrganization(search, loading){
                this.modals.sftp.suppliers = []
                loading(true);
                if(this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
                    try {
                        await this.getOrganizations(search);
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }                    
                }, 500);
            },
            filterByImport() {
                this.isFilterByImport = !this.isFilterByImport
                delete this.$refs.gofixTable.tableRequest.filter.is_import_dorjs;
                if(this.isFilterByImport) this.$refs.gofixTable.tableRequest.filter.is_import_dorjs = this.isFilterByImport;
                this.$refs.gofixTable.reloadTableKeepFilter();
            },
            async updateWONumber(callback){
                const { ids, resolve, reject } = await callback();
                this.modals.update_wo_number.data = [];

                // let _key = 0;
                const idsExits = [];
                // this.tableItems.map(item => {
                    
                //     if(ids.includes(item.item_id)) {
                //         if ( !idsExits.includes(item.id) ) {
                //             idsExits.push(
                //                 item.id
                //             )

                //             this.modals.update_wo_number.data.push({
                //                 id: item.id, 
                //                 dorj_number: item.dorj_number ? item.dorj_number : null, 
                //                 wo_ref_no: item.wo_ref_no ? item.wo_ref_no : null, 
                //                 wo_date: item.wo_date ? moment(item.wo_date).toDate() : null,
                //             });
                //         }
                //     }
                    
                //     _key++
                // });

                ids.map(item => {
                    if ( !idsExits.includes(item.id) ) {
                        idsExits.push(
                            item.id
                        )

                        this.modals.update_wo_number.data.push({
                            id: item.id, 
                            dorj_number: item.dorj_number ? item.dorj_number : null, 
                            wo_ref_no: item.wo_ref_no ? item.wo_ref_no : null, 
                            wo_date: item.wo_date ? moment(item.wo_date).toDate() : null,
                        });
                    }
                })

                this.modals.update_wo_number.open = true;
            },
            async submitUpdateWONumber() {
                
                let dataUpdate = {
                    'items': {}
                };

                let term_ = []

                this.modals.update_wo_number.data.map(item => {
                    term_.push({
                        id: item.id, 
                        wo_ref_no: item.wo_ref_no ? item.wo_ref_no : null, 
                        wo_date: item.wo_date ? moment(item.wo_date).format('YYYY-MM-DD') : null,
                    });
                });

                this.modals.update_wo_number.loading = true;
                dataUpdate.items = term_;
                
                this.$store.dispatch("PartReplacementController/updateWONumber", dataUpdate)
                .then(response => {
                    this.modals.update_wo_number.data = [];
                    this.modals.update_wo_number.loading = false;
                    this.modals.update_wo_number.open = false;
                    this.$alertNotification("Successfully Updated Part Replacement History", "success"); 

                    this.$refs.gofixTable.reloadTableItems();
                })
                .catch(err => {
                    this.modals.update_wo_number.loading = false;
                    if( err.response.data.error && err.response.data.error.message ) {
                        this.$alertNotification(err.response.data.error.message, "danger"); 
                    }
                })
            },
            modalSubmitDocument() {
                this.getOrganizations();
                this.modals.import_dorj.data.file = null
                this.modals.import_dorj.data.supplier = null
                this.modals.import_dorj.open = true
            },
            async submitDocumentDORJ() {
                if(!this.modals.import_dorj.data.file) {
                    return this.$alertNotification("Please choose a file import.", "danger");
                }

                if(!this.modals.import_dorj.data.supplier) {
                    return this.$alertNotification("Please choose a file import.", "danger");
                }

                if(this.modals.import_dorj.loading) return
                this.modals.import_dorj.loading = true
                

               await this.$store.dispatch(`BatchSubmissionController/importItems`, {
                   file_import: this.modals.import_dorj.data.file,
                   file_type: 'DORJ',
                   supplier_id: this.modals.import_dorj.data.supplier.id
               })
               .then(response => {
                   if(response.data.data.data && response.data.data.data.count && response.data.data.data.count.failed) {
                       this.$alertNotification("Some rows cannot be imported. Please go to Import Logs for more details.", "danger");
                   } else {
                       this.$alertNotification("Successfully imported", "success");
                   }
                   this.$refs.gofixTable.reloadTableItems();
                   this.modals.import_dorj.loading = false
                   this.modals.import_dorj.open = false
               })
               .catch(error => {
                    this.modals.import_dorj.loading = false
                    this.modals.import_dorj.open = false
                    if(error.response.data.error && error.response.data.error.message) {
                       if(error.response.data.error.message.hasOwnProperty('data')) {
                           if(error.response.data.error.message.data) {
                               if(error.response.data.error.message.data.count) {
                                   if(error.response.data.error.message.data.count.failed) {
                                       this.$alertNotification("Some rows cannot be imported. Please go to Import Logs for more details.", "danger")
                                   }
                                   return
                               }
                               return this.showToast(error.response.data.error.message.data)
                           }
                           return this.$alertNotification(error.response.data.error.message.message, "danger")
                       }
                    }
                    this.$refs.gofixTable.reloadTableItems();
                    this.$alertNotification(error.response.data.error.message, "danger")
               });
            },
            showToast(data) {
                // Use a shorter name for this.$createElement
                const h = this.$createElement
                let elements = []
                for(let i = 0; i < data.length; i++) {
                    elements.push(h('li', data[i]))
                }
                
                // Create the message
                const vNodesMsg = h(
                    'div',
                    [
                        h(
                            'p', 
                            { class: ['mb-0'] },
                            [ 'Please check the list of errors below:' ]
                        ),
                        h(
                            'ul',
                            { class: ['mb-0', 'pl-25'] },
                            elements
                        ),
                        
                    ]
                )
                // Pass the VNodes as an array for message and title
                this.$bvToast.toast([vNodesMsg], {
                    title: "Notification",
                    solid: true,
                    variant: 'danger',
                    autoHideDelay: 3000,
                })
            }
        }
    }
</script>